import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { TranslateService } from '@ngx-translate/core';
import { RoleDto } from '@pages/settings-page/access-control-settings/roles/grid/interfaces';
import UserUtils from '@shared/utils/user.utils';
import { ColDef } from 'ag-grid-community';

@Injectable()
export class AddUserRoleService {
  private translate = inject(TranslateService);

  readonly colDefs: ColDef<RoleDto>[] = [
    {
      headerName: 'Grid.id',
      field: 'RoleID',
      type: [ColumnType.Id],
      hide: true,
    },
    {
      filter: 'agTextColumnFilter',
      field: 'Name',
      valueGetter: ({ colDef, data }) =>
        UserUtils.translationValueGetter(colDef, 'Name', data!, this.translate),
      headerName: 'RolesGrid.RoleName',
      type: [ColumnType.Text],
      width: 350,
      enableRowGroup: false,
    },
    {
      filter: 'agTextColumnFilter',
      field: 'Description',
      valueGetter: ({ colDef, data }) =>
        UserUtils.translationValueGetter(
          colDef,
          'Description',
          data!,
          this.translate
        ),
      headerName: 'RolesGrid.RoleDescription',
      type: [ColumnType.Text],
      flex: 1,
      enableRowGroup: false,
    },
    {
      field: 'TranslationKey',
      type: [ColumnType.Text],
      hide: true,
      suppressColumnsToolPanel: true,
    },
    { field: 'Enabled', hide: true, suppressColumnsToolPanel: true },
  ];
}
